module.exports = {
          srcSet: __webpack_public_path__ + "2d83a9ee.jpg"+" 700w"+","+__webpack_public_path__ + "533cf363.jpg"+" 1400w"+","+__webpack_public_path__ + "ad4e7b52.jpg"+" 2048w",
          images:[ {path: __webpack_public_path__ + "2d83a9ee.jpg",width: 700,height: 525},{path: __webpack_public_path__ + "533cf363.jpg",width: 1400,height: 1050},{path: __webpack_public_path__ + "ad4e7b52.jpg",width: 2048,height: 1536}],
          src: __webpack_public_path__ + "2d83a9ee.jpg",
          toString:function(){return __webpack_public_path__ + "2d83a9ee.jpg"},
          
          width: 700,
          height: 525
        }